export default __webpack_public_path__ + "static/media/1858.2c209f56.png";